var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 22,
    viewBox: "0 0 10 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3V13.54C7.76257 13.9803 8.35855 14.6599 8.69552 15.4734C9.03249 16.2869 9.09161 17.1888 8.86371 18.0394C8.63581 18.8899 8.13362 19.6415 7.43505 20.1775C6.73647 20.7136 5.88054 21.0041 5 21.0041C4.11946 21.0041 3.26353 20.7136 2.56496 20.1775C1.86638 19.6415 1.3642 18.8899 1.1363 18.0394C0.908398 17.1888 0.967516 16.2869 1.30448 15.4734C1.64145 14.6599 2.23743 13.9803 3 13.54V3C3 2.46957 3.21072 1.96086 3.58579 1.58579C3.96086 1.21071 4.46957 1 5 1C5.53043 1 6.03914 1.21071 6.41422 1.58579C6.78929 1.96086 7 2.46957 7 3Z",
    stroke: "#596173",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempIcon);
export default __webpack_public_path__ + "static/media/tempIcon.3c5999ef0f5697769f5cbca664e8e488.svg";
export { ForwardRef as ReactComponent };